/**
 * Theme main entry point.
 *
 * @package mindgrub-starter-theme
 */

import analytics 	from './components/analytics.js';
import social 		from './components/social.js';
import ui 			from './components/ui.js';
import slick 		from './components/slick-slider';
import rangeSlider	from './components/rangeslider-setup';
import factCard		from './components/fact-cards';

/**
 * Initialize the app on DOM ready
 */
$(
	function() {
		analytics.init(
			{
				addGA: false,
				addGTM: false
			}
		);
		social.init();
		ui.init();
		slick.init();
		rangeSlider.init();
		factCard.init();
	}
);



// WEBPACK FOOTER //
// ./scripts/theme.js